module.exports = __webpack_public_path__ + "static/red_left-95031853ffcba48569b975413b5a5c5f.png";